// The homepage Discover table has a horizontally-scrollable body with a sticky
// first column (the token name). When the user scrolls right, the remaining
// columns slide behind the sticky first column; if that first column's
// background is not fully opaque the scrolling content "bleeds" through and
// the token name visually overlaps with whatever column is scrolling behind
// it.
//
// The Matcha design tokens model the table's card surface via
// `--color-special-background-card`, which is a translucent value in dark mode
// (`rgba(175, 188, 230, 0.08)`). Layering it over the solid
// `--color-special-background-app` produces the table's visual card colour.
// Applying the same layered composition directly to the sticky first cell
// recreates that visual while remaining fully opaque, so the cell covers the
// scrolling siblings underneath it.
//
// `bg-token-alphalight-200` (the row hover color) is also translucent in both
// themes, so the hover variant stacks the alphalight overlay on top of the
// card overlay to match the hover look produced by the row's own
// `hover:bg-token-alphalight-200`.
//
// Applied to TRs that carry `group` so `group-hover:` targets the hovered row.
export const STICKY_FIRST_CELL_BG_CLASSES = [
  'first:bg-special-background-app',
  'first:bg-[linear-gradient(0deg,var(--color-special-background-card),var(--color-special-background-card))]',
  'group-hover:first:bg-[linear-gradient(0deg,var(--color-token-alphalight-200),var(--color-token-alphalight-200)),linear-gradient(0deg,var(--color-special-background-card),var(--color-special-background-card))]',
] as const;
